import { Controller } from "@hotwired/stimulus"
import noUiSlider from "nouislider"

export default class extends Controller {
  static targets = ["slider", "minInput", "maxInput"]
  static values = {
    min: Number,
    max: Number,
    start: Array,
    step: { type: Number, default: 1 },
    connect: { type: Boolean, default: true },
    tooltips: { type: Boolean, default: true },
    format: { type: String, default: "integer" } // integer or float
  }

  connect() {
    if (!this.hasSliderTarget) return
    
    const options = {
      start: this.startValue || [this.minValue || 0, this.maxValue || 100],
      range: {
        'min': this.minValue || 0,
        'max': this.maxValue || 100
      },
      step: this.stepValue,
      connect: this.connectValue,
      tooltips: this.tooltipsValue,
      format: {
        to: (value) => {
          return this.formatValue === "integer" ? Math.round(value) : parseFloat(value).toFixed(2)
        },
        from: (value) => {
          return parseFloat(value)
        }
      }
    }

    this.slider = noUiSlider.create(this.sliderTarget, options)
    
    // Update hidden inputs when slider values change
    this.slider.on('update', (values, handle) => {
      if (this.hasMinInputTarget && this.hasMaxInputTarget) {
        this.minInputTarget.value = values[0]
        this.maxInputTarget.value = values[1]
      }
      
      // Dispatch a custom event that can be listened to by other controllers
      this.dispatch('change', { detail: { values: values } })
    })
    
    // Add event listeners to input fields
    if (this.hasMinInputTarget) {
      this.minInputTarget.addEventListener('input', this.updateSliderFromInputs.bind(this))
    }
    
    if (this.hasMaxInputTarget) {
      this.maxInputTarget.addEventListener('input', this.updateSliderFromInputs.bind(this))
    }
  }
  
  updateSliderFromInputs() {
    if (!this.slider) return
    
    const minValue = this.hasMinInputTarget ? parseFloat(this.minInputTarget.value) || this.minValue || 0 : this.minValue || 0
    const maxValue = this.hasMaxInputTarget ? parseFloat(this.maxInputTarget.value) || this.maxValue || 100 : this.maxValue || 100
    
    this.slider.set([minValue, maxValue])
  }

  disconnect() {
    if (this.slider) {
      this.slider.destroy()
    }
  }
}
